<template>
  <div class="cooperation">
    <div class="container">
      <h2 class="title">让我们开始合作吧</h2>
      <p class="content">我们将竭诚为您提供最优质的物流运输服务</p>
      <button class="action">即刻开始</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cooperation'
}
</script>

<style scoped>
.cooperation {
  position: relative;
  margin-top: 50px;
  width: 100%;
  height: 250px;
  background-color: rgb(220, 220, 220);
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.title {
  font-size: 35px;
  color: rgb(255, 171, 63);
}

.content {
  color: rgb(99, 99, 99);
}

.action {
  margin-top: 20px;
  background-color: rgb(225, 171, 63);
  color: white;
  border: none;
  height: 50px;
  width: 150px;
  border-radius: 40px;
  font-size: 25px;
  letter-spacing: 2px;
  font-weight: bolder;
}
</style>
